var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetry = function SvgRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.07 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 2.8A9.47 9.47 0 0 0 7.6 0a8.94 8.94 0 0 0-6.2 2.4c-.3.1-.4 0-.4-.2v-.7A.47.47 0 0 0 .5 1a.64.64 0 0 0-.5.5v2.3a.47.47 0 0 0 .5.5h2.3a.47.47 0 0 0 .5-.5.47.47 0 0 0-.5-.5h-.7c-.2 0-.2-.1-.2-.2A9.3 9.3 0 0 1 7.6 1a8.4 8.4 0 0 1 6 2.5 8.49 8.49 0 0 1-12 12 .48.48 0 0 0-.7 0 .48.48 0 0 0 0 .7A9.4 9.4 0 0 0 7.6 19a9.23 9.23 0 0 0 6.7-2.8 9.48 9.48 0 0 0 0-13.4"
  })));
};
export default SvgRetry;